export default function enableNavigation() {
    const navigation = document.getElementById('primary-nav');
    const button = document.getElementById('navigation-button');
    button.addEventListener('click', function (event) {
        const isOpen = navigation.classList.contains('primary-nav-open');
        if (isOpen) {
            button.classList.remove('navigation-button-open');
            navigation.classList.add('primary-nav-closing');
            navigation.classList.remove('primary-nav-closing');
            navigation.classList.remove('primary-nav-open');
        } else {
            button.classList.add('navigation-button-open');
            navigation.classList.add('primary-nav-open');
        }
        button.setAttribute('aria-expanded', isOpen);
        event.preventDefault();
    });
}
